import { PropsCourseLineForm } from '@/domains/course-lines/entities';
import * as yup from 'yup';

export const validateCourseLine = (props: PropsCourseLineForm) => {
  const schemaCourseLine = yup.object().shape({
    name: yup.string().required('Name is empty').trim(),
    description: yup.string().required('Description is empty').trim(),
    category: yup.string().required('Category is empty').trim(),
    basePrice: yup.number().required('Base price is empty').min(0, 'Base price must be positive'),
    operationMethods: yup.array(),
  });

  return { schemaCourseLine };
};
